import { render, staticRenderFns } from "./DossierSelect.vue?vue&type=template&id=03dff427&"
import script from "./DossierSelect.vue?vue&type=script&lang=ts&"
export * from "./DossierSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03dff427')) {
      api.createRecord('03dff427', component.options)
    } else {
      api.reload('03dff427', component.options)
    }
    module.hot.accept("./DossierSelect.vue?vue&type=template&id=03dff427&", function () {
      api.rerender('03dff427', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DossierSelect.vue"
export default component.exports